export default {
  props: {
    highlight: {
      type: Object,
      required: true
    }
  },
  computed: {
    linkComponent() {
      if (/^#|http(s)?:\/\//.test(this.highlight.button.url)) return 'a'
      return 'router-link'
    },
    hasImage() {
      return this.highlight.media && this.highlight.media.filestorename && this.highlight.media.filepath
    },
    hasHighlightButton() {
      const btn = this.getHighlightButton
      return btn && btn.url
    },
    getImage() {
      return this.highlight.media
    },
    getPreset() {
      if (this.getImage?.data?.iconratio) {
        const ratio = this.getRatio
        return ratio ? `constructed-feature-${ratio}` : ''
      }
      return 'featurepagehighlight'
    },
    getRatio() {
      if (this.getImage?.data?.iconratio) {
        return this.getImage.data.iconratio !== 'notset' ? this.getImage.data.iconratio : ''
      }
      return ''
    },
    getHighlightTitle() {
      return this.highlight.title
    },
    getHighlightLeadline() {
      return this.highlight.leadline
    },
    getHighlightDescription() {
      return this.highlight.description
    },
    getHighlightButton() {
      return this.highlight.button
    }
  }
}
